import {isPc} from '../utils/util';

export default {
    "FEMALE":1
}

export const isPcClient = isPc();